import {Button, FormControlLabel, Grid, Switch, TextField} from "@mui/material";
import React, {useEffect, useMemo, useState} from "react";
import {IRole} from "@models/roles/roles.ts";
import {useRoles} from "@components/roles/hooks/useRoles.ts";
import {IDuplicaRoleDto} from "@components/roles/models/IDuplicaRoleDto.ts";
import {useAlert} from "@contexts/hooks/useAlert.ts";
import {RoleInfoList} from "@components/roles/info/RoleInfoList.tsx";

interface DuplicaRoleComponentProps {
    role: number | IRole,
    onCreate?: (r?: IRole) => void;
}

export function DuplicaRoleComponent(props: DuplicaRoleComponentProps) {
    const {createAlertFromResponse} = useAlert()
    const {getRole, duplicaRole} = useRoles()

    const [role, setRole] = useState<IRole | undefined>()
    const [value, setValue] = useState<IDuplicaRoleDto>({
        idRole: 0,
        nome: '',
        descricao: '',
        clonarPermissoes: true,
        clonarMembros: false,
    })

    const handleCreate = () => {
        duplicaRole({data: value}).then((x) => {
            createAlertFromResponse(x)
            if (props.onCreate) {
                return props.onCreate(x.items)
            }
        })
    }

    useEffect(() => {
        if (role != null) {
            setValue({
                idRole: role.id,
                nome: "Copia de " + role.nome,
                descricao: role.descricao,
                clonarPermissoes: true,
                clonarMembros: true
            })
        }
    }, [role]);

    useEffect(() => {
        if (typeof props.role == 'number') {
            getRole({data: {id: props.role as number}}).then(x =>
                setRole(x.items)
            )
        } else {
            setRole(props.role)
        }
    }, [props.role]);

    const nomeValid = useMemo(() => {
        return value.nome.length > 4
    }, [value.nome])

    const allValid = useMemo(() => {
        return nomeValid
    }, [nomeValid])

    return (role != null && <Grid container spacing={1.5}>
        <Grid size={12}>
            <RoleInfoList value={role}/>
        </Grid>
        <TextField label="Nome da nova role"
                   error={!nomeValid}
                   helperText={nomeValid ? '' : 'Nome da role deve ter pelo menos 5 caracteres'}
                   value={value.nome}
                   onChange={(e) => {
                       setValue(prev => ({...prev, nome: e.target.value}))
                   }} variant="outlined" fullWidth/>
        <TextField label="Descricao da role nova"
                   value={value.descricao}
                   onChange={(e) => {
                       setValue(prev => ({...prev, descricao: e.target.value}))
                   }}
                   variant="outlined" fullWidth/>
        <Grid size={12}>
            <FormControlLabel label={'Copiar permissoes'}
                              checked={value.clonarPermissoes}
                              onChange={(_e, v) => {
                                  setValue(prev => ({...prev, clonarPermissoes: v}))
                              }} control={<Switch/>}/>
            <FormControlLabel label={'Copiar membros'}
                              checked={value.clonarMembros}
                              onChange={(_e, v) => {
                                  setValue(prev => ({...prev, clonarMembros: v}))
                              }} control={<Switch/>}/>
        </Grid>
        <Button variant="contained" color="primary" disabled={!allValid} fullWidth
                onClick={handleCreate}>Duplicar</Button>
    </Grid>)
}